export const SHAPE_NODE_MAIN_SHAPE_NAME = 'MAIN_SHAPE';
